<template>
  <CRow>
    <CCol sm="6" xl="3" v-for="item in items" :key="item.id">
      <CCard :color="item.color" textColor="white">
        <CCardBody>
          <div class="d-flex">
            <CIcon :content="$options[item.title]" /> 
            <div class="pl-1 text-uppercase">{{ item.title }}</div>
          </div>
          
          <div style="font-size: 2.5rem;">{{ item.data }}</div>
        </CCardBody>
      </CCard>
    </CCol>
    <!-- <CCol sm="6" lg="3" v-for="item in items" :key="item.id">
      <CWidgetDropdown :color="item.color" :header="`${item.data}`" :text="item.title">
        <template #default>
          <CDropdown
            color="transparent p-0"
            placement="bottom-end"
          >
            <template #toggler-content>
             <CIcon name="cil-settings"/>
            </template>
            <CDropdownItem>Action</CDropdownItem>
            <CDropdownItem>Another action</CDropdownItem>
            <CDropdownItem>Something else here...</CDropdownItem>
            <CDropdownItem disabled>Disabled action</CDropdownItem>
          </CDropdown>
        </template>
        <template #footer>
          <CChartBarSimple
            class="mt-3 mx-3"
            style="height:70px"
            background-color="rgb(250, 152, 152)"
            label="Members"
            labels="months"
          />
          <CChartLineSimple
            pointed
            class="mt-3 mx-3"
            style="height:70px"
            :data-points="[65, 59, 84, 84, 51, 55, 40]"
            :point-hover-background-color="item.color"
            :label="item.title"
            labels="months"
          />
        </template>
      </CWidgetDropdown>
    </CCol> -->
  </CRow>
</template>

<script>
// import { CChartLineSimple, CChartBarSimple } from '../charts/index.js'
import { cilContact, cilCart, cilWallet, cilMoney } from '@coreui/icons';

export default {
  name: 'WidgetsTotal',
  props: {
    items: {
      type: Array,
      default: []
    }
  },
  Clients: cilContact,
  Orders: cilCart,
  Credits: cilWallet,
  Sales: cilMoney
}
</script>
